import { ContainerModule, interfaces } from 'inversify';

const catalogModule = new ContainerModule((bind: interfaces.Bind) => {
});

export default catalogModule;
